import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  categories: [],
  exams: [],
  user: {},
  isLoadingExam: false,
  transactions: [],
  deposits: [],
  isLoadingTransaction: false,
  cityList: [],
  wardList: [],
  isLoadingCOD: false,
  codStatus: '',
  codMessage: ''
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};